export default class APIService{

  constructor(){
    this.loader = null;
  }

  show(boom){
      this.loader = boom.$loading.show({
                  // Optional parameters
                  container: true ? null : this.$refs.formContainer,
                  canCancel: false,
                  width:40,
                  height:40,
                  color:"#2a2a2e",
                  backgroundColor: '#b5b5b5',
                  opacity:.6
                });
  }

  hide(){
    this.loader.hide();
  }

}
